import { useIbanXSActions } from "features/openBanking/actions";
import { useOpenBankingResource } from "../shared/OpenBankingResource";

export default function useIbanXS() {
    const { onRowClick } = useOpenBankingResource();

    const {
        getIbanXsBanks: getResource,
        downloadCsv
    } = useIbanXSActions();

    return {
        downloadCsv,
        getResource,
        onRowClick
    };
};
